import { TextBox } from '@apply/components';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StreetAddress2Field = () => {
    const value = useBrokerDetailsStore((s) => s.businessAddress.street2);
    const updateBusinessAddress = useBrokerDetailsStore((s) => s.updateBusinessAddress);
    const changed = useBrokerFieldFieldChanged(FormField.BusinessStreet2);
    
    return (
        <>
            <TextBox
                id='cAddress2'
                value={value}
                onChange={(v) => updateBusinessAddress({ street2: v })}
                width={'100%'}
                label='Street Address 2'
                placeholder='Suite or unit number if applicable (e.g. 250 East 55th St., Unit 5B)'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon icon={'asterisk'} className='required-icon' />
            </ShowIf>
        </>
    );
};

